import React, { useEffect, useState } from 'react';

const UserPoints = ({ points, editable, onSave }) => {
  const [editMode, setEditMode] = useState(false);

  const resolvedPoints =
    points?.points ??
    points?.totalPoints ??
    points?.total_points ??
    (typeof points === 'number' ? points : 0);

  const [newPoints, setNewPoints] = useState(resolvedPoints);

  useEffect(() => {
    const updatedPoints =
      points?.points ??
      points?.totalPoints ??
      points?.total_points ??
      (typeof points === 'number' ? points : 0);

    setNewPoints(updatedPoints);
  }, [points]);

  const handleSave = () => {
    onSave(newPoints);
    setEditMode(false);
  };

  const goToReceipt = () => {
    const patientId = localStorage.getItem("patientId");
    if (!patientId) {
      alert("No patient ID found.");
      return;
    }
    window.open(`/patientreceipt?patientId=${patientId}`, '_blank');
  };

  return (
    <div className="user-points">
      <h2>Total Points:</h2>
      {editMode ? (
        <>
          <input
            type="number"
            value={newPoints}
            onChange={(e) => setNewPoints(Number(e.target.value))}
            className="edit-input"
          />
          <button onClick={handleSave} className="save-button">Save</button>
          <button onClick={() => setEditMode(false)} className="cancel-button">Cancel</button>
        </>
      ) : (
        <>
          <p>{resolvedPoints}</p>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {editable && (
              <button onClick={() => setEditMode(true)} className="edit-button">Edit</button>
            )}
            <button onClick={goToReceipt} className="save-button">View Receipt</button>
          </div>
        </>
      )}
    </div>
  );
};

export default UserPoints;
